import { PaymentMethodType, SepaDirectDebitProviderState, SepaPaymentMethodDetails } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { LocalizedEnum } from '@mews/framework';
import { Stack, Tag, Typography } from '@optimus-web/core';
import { PaymentMethodIcon } from '../../../../../../../components/commander-ui/PaymentMethodIcon';
import { PaymentDetailsSidebarGrid } from '../PaymentDetailsSidebarGrid';
import { PaymentDetailsSidebarRow, PaymentDetailsSidebarRowTypography } from '../PaymentDetailsSidebarRow';
import { paymentMethodImageTypeMap, sepaStateTagVariantMap } from '../../utils';

const sepaLastDigitsRow = (type?: PaymentMethodType, lastDigits?: string | null) => {
    if (!type || !lastDigits) {
        return <PaymentDetailsSidebarRowTypography labelTextKey={TextKey.Method} value={TextKey.Unspecified} />;
    }

    return (
        <PaymentDetailsSidebarRow labelTextKey={TextKey.Method}>
            <Stack itemAlignment="center" spacing="50">
                <PaymentMethodIcon type={paymentMethodImageTypeMap[type]} small />
                <Typography textStyle="bodyMedium" as="div">
                    {lastDigits}
                </Typography>
            </Stack>
        </PaymentDetailsSidebarRow>
    );
};

const sepaStatusRow = (status: SepaDirectDebitProviderState) => (
    <PaymentDetailsSidebarRow labelTextKey={TextKey.Status}>
        <Tag variant={sepaStateTagVariantMap[status]}>
            <LocalizedEnum prefix="SepaDirectDebitProviderState" value={status} />
        </Tag>
    </PaymentDetailsSidebarRow>
);

export const SepaPaymentMethod = ({ sepaPaymentMethod }: { sepaPaymentMethod: SepaPaymentMethodDetails }) => {
    return (
        <PaymentDetailsSidebarGrid>
            {sepaLastDigitsRow(PaymentMethodType.SepaDirectDebit, sepaPaymentMethod.iban)}
            {sepaStatusRow(sepaPaymentMethod.state)}
            <PaymentDetailsSidebarRow labelTextKey={TextKey.PayoutDetailMandateReference}>
                {sepaPaymentMethod.mandateReference && (
                    <Typography textStyle="bodyMedium" as="div">
                        {sepaPaymentMethod.mandateReference}
                    </Typography>
                )}
            </PaymentDetailsSidebarRow>
        </PaymentDetailsSidebarGrid>
    );
};
